<template>
  <!-- Première cellule vide pour la colonne fixe -->
  <div class="p-0 bg-white" :style="{ gridColumn: `span 1` }">
    <select 
      class="bg-[#1E1017] text-white rounded-2xl rounded-br-none  p-1 pl-2 w-full truncate h-8 select-none cursor-pointer hover:bg-[#E8535D]"
      v-model="state.selectedRows"
    >
      <option v-for="row in state.rows" :key="row.name" :value="row">{{ row.name }}</option>
    </select>
  </div>

  <!-- Pour chaque jour, pour chaque heure générée, on affichera l'heure avec un fond conditionnel -->
  <div v-for="dIndex in dateArrays.days.length" :key="dIndex" class="pt-2 text-left flex text-sm bg-[#1E1017] text-white rounded-t-xl h-8" :style="{ gridColumn: `span ${slots.length}` }">
    <template v-for="hourGroup in hourSubdivision" :key="hourGroup.startHour">
      <div :style="{ width: `${hourGroup.time * minuteWidth}px` }" class="border-r border-b border-gray-400 p-1 select-none">
        {{ hourGroup.startHour }}
      </div>
    </template>
  </div>
</template>

<script>
import { inject } from 'vue';

export default{
  props:{
    slots: Array,
    slotInterval: Number,
    hourMaxTime: Number,
    minuteWidth: Number,
  },
  setup(){
    const state = inject('state');
    const dateArrays = inject('dateArrays');
    const parameters = inject('parameters');
    return { state, dateArrays, parameters };
  },
  computed:{
    hourSubdivision(){
      let subTime = 60;
      switch (this.dateArrays.days.length){
        case 1:
          subTime = 60;
          break;
        case 2:
          subTime = 120;
          break;
        case 3:
          subTime = 180;
          break;
        case 4:
          subTime = 240;
          break;
        case 5:
          subTime = 360;
          break;
        case 6:
          subTime = 360;
          break;
        case 7:
          subTime = 480;
          break;
      }

      const startMinute = this.parameters.night ? 0 : this.parameters.startMinute;
      const endMinute = this.parameters.night ? 60 * 24 : this.parameters.endMinute;
      const hourSub = [];
      
      let actM = startMinute;
      while(actM < endMinute){
        const hourGroup = {startHour: this.formatMinutesToHour(actM), time: subTime};

        if(actM % subTime != 0){
          console.log((actM % subTime));
          hourGroup.time = subTime - (actM % subTime);
          actM -= actM % subTime;
        }

        if(actM + hourGroup.time > endMinute){
          hourGroup.time = endMinute - actM;
        }

        hourSub.push(hourGroup);
        actM += subTime;
      }

      return hourSub;
    },
  },
  methods:{
    formatMinutesToHour(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    }
  }
}
</script>